import React from 'react';
import { MenuItem, Button, Link } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { iRootState, Dispatch } from '../../redux/store';
import cleanFileName from '../../cleanFileName';
import quotesBaseUrl from '../../quotesBaseUrl';
import { AnalyticsEventKeys } from '../../constants';

const DownloadAllButton = function DownloadAllButton(): React.ReactElement | null {
  const dispatch = useDispatch<Dispatch>();

  const quoteId = useSelector((state: iRootState) => state.quote.id);
  const zipFileName = useSelector(
    (state: iRootState) => state.quote.zipFileName
  );

  if (!zipFileName) {
    return null;
  }
  const onClick = function handleOnClick(): void {
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.DownloadAllClicked
    });
  };
  const cleanedZipFileName = cleanFileName(zipFileName);

  const href = `${quotesBaseUrl()}/${quoteId}/${cleanedZipFileName}.zip`;

  return (
    <MenuItem>
      <Button fullWidth component={Link} href={href} onClick={onClick}>
        <FormattedMessage id='downloadall' defaultMessage='Download All' />
      </Button>
    </MenuItem>
  );
};

export default DownloadAllButton;
